import { useFirestore } from 'reactfire'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { Button, Col, Form, Radio, Row, Space, theme, Typography } from 'antd'
import { doc, setDoc } from 'firebase/firestore'
import { errorResponse } from '../../lib/errorResponse'
import { gutter } from '../../lib/layout'
import { useTranslation } from 'react-i18next'

export function StepQuestions({ onboarding, goToNext, goToPrevious }) {
  const firestore = useFirestore()
  const { companyUid } = useParams()
  const [loading, setLoading] = useState(false)

  const { token } = theme.useToken()
  const { t } = useTranslation()

  async function onSubmit(values) {
    setLoading(true)
    try {
      await setDoc(
        doc(firestore, 'onboarding', companyUid),
        {
          proofOfWagesSubmitted: values.proofOfWagesSubmitted,
          taxPaymentsMethod: values.taxPaymentsMethod,
        },
        { merge: true }
      )
      goToNext()
    } catch (e) {
      errorResponse(e)
    } finally {
      setLoading(false)
    }
  }

  const [form] = Form.useForm()

  const initialValues = {
    proofOfWagesSubmitted: onboarding.proofOfWagesSubmitted,
    taxPaymentsMethod: onboarding.taxPaymentsMethod,
  }

  return (
    <>
      <Typography.Paragraph style={{ marginBottom: token.marginLG }}>
        {t('frontend:onboarding.questionsIntro')}
      </Typography.Paragraph>
      <Form
        style={{ marginTop: token.marginXL }}
        form={form}
        onFinish={onSubmit}
        colon={false}
        layout="vertical"
        initialValues={initialValues}
      >
        <Row gutter={gutter}>
          <Col span={24}>
            <Form.Item
              label={t('frontend:onboarding.proofOfWagesLabel')}
              name={['proofOfWagesSubmitted']}
              rules={[
                {
                  required: true,
                  message: t('frontend:onboarding.fieldRequired'),
                },
              ]}
            >
              <Radio.Group buttonStyle="solid">
                <Radio.Button value={true}>
                  {t('frontend:common.yes')}
                </Radio.Button>
                <Radio.Button value={false}>
                  {t('frontend:common.no')}
                </Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t('frontend:onboarding.taxPaymentsMethodLabel')}
              name={['taxPaymentsMethod']}
              rules={[
                {
                  required: true,
                  message: t('frontend:onboarding.fieldRequired'),
                },
              ]}
            >
              <Radio.Group buttonStyle="solid">
                <Radio.Button value="SEPADebit">
                  {t('frontend:onboarding.sepaDebit')}
                </Radio.Button>
                <Radio.Button value="BankTransfer">
                  {t('frontend:onboarding.bankTransfer')}
                </Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        <div style={{ textAlign: 'right', marginTop: token.marginLG }}>
          <Space>
            <Button type="text" onClick={() => goToPrevious()}>
              {t('frontend:common.back')}
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {t('frontend:onboarding.next')}
            </Button>
          </Space>
        </div>
      </Form>
    </>
  )
}
